export default function simpleInterval(cb, intervalStepMs) {
  let interval = null;

  return {
    start() {
      if (interval) {
        throw new Error("can't start interval: already started");
      }
      interval = setInterval(cb, intervalStepMs);
    },

    stop() {
      if (!interval) {
        throw new Error("can't stop interval: isn't started");
      }

      clearInterval(interval);
      interval = null;
    },

    isStarted() {
      return interval !== null;
    },
  };
}
